// extracted by mini-css-extract-plugin
module.exports = {"child-wrp":"KeyServiceItem_child-wrp__3CpTd","show-all":"KeyServiceItem_show-all__u9789","item":"KeyServiceItem_item__3oKIN","link-item":"KeyServiceItem_link-item__1YEPL"};